import React, { useCallback, useEffect, useState } from "react";
import { connect } from "react-redux";

import Drawer from "antd/es/drawer";
import Steps from "antd/es/steps";
import { useIntl } from "react-intl";

import { smartPlannerViewAnalytics } from "@app/scene/activity/activityTableAnalytics";
import useHiddenZendesk from "@app/util/useHiddenZendesk";

import RouteBuilderStep from "./enum/RouteBuilderStep";
import styles from "./RouteBuilder.module.scss";
import { initializeRouteBuilder } from "./store/actions";
import useSteps from "./util/useSteps";

interface Props {
  initialize: () => void;
  onHide: () => void;
}

const RouteBuilder: React.FC<Props> = ({ initialize, onHide }) => {
  const intl = useIntl();
  useHiddenZendesk();
  const steps = useSteps(intl);

  const [step, setStep] = useState(RouteBuilderStep.SETUP_ROUTE);
  const StepComponent = steps[step].content;
  const handleBack = useCallback(() => setStep((step) => (step > 0 ? step - 1 : step)), []);
  const handleNext = useCallback(
    () => setStep((step) => (step + 1) % steps.length),
    [steps.length]
  );

  useEffect(() => {
    initialize();
  }, [initialize]);

  return (
    <Drawer
      className={styles.container}
      closable
      onClose={() => {
        smartPlannerViewAnalytics?.cancelled(["Build routes from activities", "Close pane"]);
        onHide();
      }}
      placement="right"
      title={intl.formatMessage({
        id: "activities.calendarView.routeBuilder.title",
        defaultMessage: "Create route",
        description: "Route builder title",
      })}
      visible
    >
      <div className={styles.drawerContainer}>
        <Steps className={styles.stepsBreadcrumb} current={step}>
          {steps.map(({ title }) => (
            <Steps.Step icon={<></>} key={title} title={title} />
          ))}
        </Steps>

        <StepComponent onBack={handleBack} onHide={onHide} onNext={handleNext} />
      </div>
    </Drawer>
  );
};

const mapDispatchToProps = {
  initialize: initializeRouteBuilder.request,
};

export default connect(null, mapDispatchToProps)(RouteBuilder);
